const queryRegExp = new RegExp('(query|mutation)\\s+(\\w+)', 'm')

/**
 * Retrieves the operation name from a GraphQL request.
 * @param {Object} request - The GraphQL request object.
 * @returns {string|undefined} - The operation name if found, otherwise undefined.
 */
export default function getGraphQLOperationName(request) {
	if (!request || request.method !== 'POST') return

	const contentType = request.requestHeaders?.['content-type'] || request.requestHeaders?.['Content-Type']
	if (contentType && contentType !== 'application/json') return

	let requestBody = getNetworkRequestBody(request)
	if (!requestBody) return

	// if requestBody is an object and includes the property operationName, return it
	if (requestBody.operationName) return requestBody.operationName

	// if the requestBody is object and includes the property query (optional),
	// try to extract the operationName from it
	const operationNameFromQuery = matchOperationNameFromString(requestBody.query)
	if (operationNameFromQuery) return operationNameFromQuery

	// last attempt, try to extract the operation name from the body string
	return matchOperationNameFromString(typeof requestBody === 'string' ? requestBody : JSON.stringify(requestBody))
}

function getNetworkRequestBody(request) {
	const requestBody = Array.isArray(request.requestBody) ? request.requestBody[0] : request.requestBody
	return requestBody?.raw || requestBody
}

function matchOperationNameFromString(string) {
	if (!string || typeof string !== 'string') return
	const operationNameMatch = string.match(queryRegExp)
	return operationNameMatch?.[2]
}
